import { useEffect, useState } from 'react'

import { SecondaryBase } from './../Commons/SecondaryBase'

import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'
import { MESSAGE_TYPE, useFloatMessage } from './../../Providers/FloatMessage'
import { Prepare as BLPrepare, Start as BLStart, Stop as BLStop } from './../../../utilities/BL/Admin/Games/LightShow'

import { Confirm } from './../../Commons/Modals/Confirm'


/**
 * Componente LightShow (Admin)
 * Panel de control para el operador de la dinámica de Sincronización de Flashes.
 */
const LightShow = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage()

    const PRESETS = {
        KILOMETROS_KARAOKE: 1,
        NOPODRAS_KARAOKE: 2,
        BASICO: 3,
        SIRENA: 4
    }

    // ==========================================
    // 1. ESTADOS DE CONFIGURACIÓN DEL SHOW
    // ==========================================
    const [beatsPerMinute, setBeatsPerMinute] = useState(118);
    const [currentSystemStatus, setCurrentSystemStatus] = useState('Juego inactivo. Configura el ritmo y colores.');

    // Configuracion por defecto "Clásica" (Sirve para resetear la memoria)
    const defaultBasicFrames = [
        //{ id: 1, color: '#FFFFFF', flashOn: true },
        { id: 1, color: '#038244', flashOn: true },
        { id: 2, color: '#000000', flashOn: false }
    ];

    // Estado principal del ciclo de colores/luz
    const [animationFrames, setAnimationFrames] = useState(defaultBasicFrames);

    // ==========================================
    // 2. ESTADOS DEL MODAL DE CONFIRMACIÓN
    // ==========================================
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmModalData, setConfirmModalData] = useState(null);

    const [presetLoaded, setPresetLoaded] = useState(null);

    // ==========================================
    // 3. RECUPERACIÓN DE MEMORIA LOCAL (On Mount)
    // ==========================================
    useEffect(() => {
        // Al cargar el componente, intentamos buscar si el Admin ya había guardado un ciclo
        const savedCustomFrames = localStorage.getItem('lightShowCustomFrames');
        const savedCustomBPM = localStorage.getItem('lightShowCustomBPM');

        if (savedCustomFrames) {
            setAnimationFrames(JSON.parse(savedCustomFrames));
        }
        if (savedCustomBPM) {
            setBeatsPerMinute(parseInt(savedCustomBPM, 10));
        }
    }, []);

    // ==========================================
    // 4. MÉTODOS DEL CONSTRUCTOR DE FRAMES
    // ==========================================
    const addFrame = () => {
        // Usamos Date.now() para asegurar un ID único para el mapeo de React
        const newFrame = { id: Date.now(), color: '#FF0000', flashOn: true };
        setAnimationFrames([...animationFrames, newFrame]);
    };

    const removeFrame = (frameIdToRemove) => {
        if (animationFrames.length <= 2) {
            showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Debes tener al menos 2 frames para crear un ciclo válido.' });
            return;
        }
        setAnimationFrames(animationFrames.filter(frame => frame.id !== frameIdToRemove));
    };

    const updateFrame = (frameIdToUpdate, propertyName, newValue) => {
        setAnimationFrames(previousFrames => 
            previousFrames.map(frame => 
                frame.id === frameIdToUpdate ? { ...frame, [propertyName]: newValue } : frame
            )
        );
    };

    const loadPreset = (presetType) => {
        try {
            //if (presetType.toLowerCase() === 'NoPodrasKaraoke'.toLowerCase()) {
            if (presetType === PRESETS.NOPODRAS_KARAOKE) {
                setAnimationFrames([
                    { id: 1, color: '#038244', flashOn: true },  // Azul prende
                    { id: 2, color: '#000000', flashOn: false } // Apaga
                ]);
                setBeatsPerMinute(118); // Ajustamos el ritmo ideal para la sirena
                setPresetLoaded(PRESETS.NOPODRAS_KARAOKE)
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Preset No podrás (Karaoke) cargado exitosamente' });
    
            //} else if (presetType.toLowerCase() === 'KilometrosKaraoke'.toLowerCase()) {
            } else if (presetType === PRESETS.KILOMETROS_KARAOKE) {
                setAnimationFrames([
                    { id: 1, color: '#038244', flashOn: true },  // Azul prende
                    { id: 2, color: '#000000', flashOn: false } // Apaga
                ]);
                setBeatsPerMinute(188); // Ajustamos el ritmo ideal para la sirena
                setPresetLoaded(PRESETS.KILOMETROS_KARAOKE)
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Preset Kilómetros (Karaoke) cargado exitosamente' });
    
            //} else if (presetType.toLowerCase() === 'basic'.toLowerCase()) {
            } else if (presetType === PRESETS.BASICO) {
                setAnimationFrames(defaultBasicFrames);
                setBeatsPerMinute(118);
                setPresetLoaded(PRESETS.BASICO)
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Preset Básico cargado exitosamente' });
    
            //} else if (presetType.toLowerCase() === 'police'.toLowerCase()) {
            } else if (presetType === PRESETS.SIRENA) {
                setAnimationFrames([
                    { id: 1, color: '#0000FF', flashOn: true },  // Azul prende
                    { id: 2, color: '#000000', flashOn: false }, // Apaga
                    { id: 3, color: '#038244', flashOn: true },  // Rojo prende
                    { id: 4, color: '#000000', flashOn: false }  // Apaga
                ]);
                setBeatsPerMinute(180); // Ajustamos el ritmo ideal para la sirena
                setPresetLoaded(PRESETS.SIRENA)
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Preset Sirena cargado exitosamente' });
            }
        } catch (error) {
            setPresetLoaded(null)
            showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar cargar el preset seleccionado. Inténtalo nuevamente o inténtalo más tarde' });
        }
    };

    // --- NUEVOS MÉTODOS DE MEMORIA LOCAL ---
    const saveCustomCycleToMemory = () => {
        localStorage.setItem('lightShowCustomFrames', JSON.stringify(animationFrames));
        localStorage.setItem('lightShowCustomBPM', beatsPerMinute.toString());
        showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Tu ciclo de colores y BPM se han guardado correctamente.' });
    };

    const clearCustomCycleFromMemory = () => {
        localStorage.removeItem('lightShowCustomFrames');
        localStorage.removeItem('lightShowCustomBPM');
        
        // Restablecemos el panel a la configuración estándar
        setAnimationFrames(defaultBasicFrames);
        setBeatsPerMinute(118);
        
        showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Memoria borrada con éxito. Se ha restablecido el ciclo por defecto.' });
    };

    // ==========================================
    // 5. MÉTODOS DE LA BATUTA (Conexión API via BL)
    // ==========================================
    const executePrepareShow = async () => {
        try {
            showMessage({ type: MESSAGE_TYPE.INFO, text: 'Enviando pantalla de permiso a los aficionados...' });
            const response = await BLPrepare(beatsPerMinute, animationFrames);
    
            if (response?.success) {
                setCurrentSystemStatus('Modo Preparación: Los celulares están pidiendo permisos.');
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Señal de preparación enviada a los aficionados' });
                return { success: true };    
            }

            showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Ha habido un error al intentar enviar la pantalla de permiso a los aficionados' });
            return { success: false, message: response?.message };
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar enviar la pantalla de permiso a los aficionados' });
        }
    };

    // const executeStartShow = async () => {
    //     const response = await BLStart();
    //     if (response?.success) {
    //         setCurrentSystemStatus(`¡SHOW EN CURSO! 🌟 (${beatsPerMinute} BPM)`);
    //         showMessage({ type: MESSAGE_TYPE.SUCCESS, text: '¡El show de luces está corriendo en los dispositivos!' });
    //         return { success: true };
    //     }
    //     return { success: false, message: response?.message };
    // };

    const executeStartShow = async () => {
        try {
            // AHORA MANDAMOS LA CONFIGURACIÓN TAMBIÉN EN EL START
            showMessage({ type: MESSAGE_TYPE.INFO, text: 'Iniciado el encendido de las luces de los aficionados...' });
            const response = await BLStart(beatsPerMinute, animationFrames);
    
            if (response?.success) {
                setCurrentSystemStatus(`¡SHOW EN CURSO! 🌟 (${beatsPerMinute} BPM)`);
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'El show de luces está corriendo exitosamente en los dispositivos' });
                return { success: true };
            }

            showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Ha habido un error al intentar encender las luces de los aficionados' });
            return { success: false, message: response?.message };
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar encender las luces de los aficionados' });
        }
    };

    const executeStopShow = async () => {
        try {
            showMessage({ type: MESSAGE_TYPE.INFO, text: 'Iniciado apagado de luces de los aficionados...' });
            const response = await BLStop();
    
            if (response?.success) {
                setCurrentSystemStatus('Show Detenido 🛑 (Mantiene permisos en usuarios)');
                showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Las luces de todos los dispositivos se han apagado exitosamente' });
                return { success: true };
            }

            showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Ha habido un error al intentar apagar las luces de los aficionados' });
            return { success: false, message: response?.message };
        } catch (error) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar apagar las luces de los aficionados' });
        }
    };

    // Wrapper para abrir el Modal genérico Confirm
    const triggerModal = (messageToDisplay, actionFunction, yesButtonText) => {
        setConfirmModalData({ 
            message: messageToDisplay, 
            actionToYesButton: actionFunction, 
            textYesButton: yesButtonText, 
            textNoButton: 'Cancelar' 
        });
        setShowConfirmModal(true);
    };

    const ReturnToDashboard = async () => {
        try {
            showMessage({ type: MESSAGE_TYPE.INFO, text: 'Regresando al Dashboard...' });
            await BLResetCurrentDynamic();
            getOutOfTheDynamic();
        } catch (error) {

        }
    };

    // ==========================================
    // RENDERIZADO DEL PANEL
    // ==========================================
    return (
        <SecondaryBase actionToExecute={ReturnToDashboard}>
            {/* Header y Estatus */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                <p className='AdmRunToGoal__Title mb-3 mb-md-0'>
                    <i className='bi bi-phone-vibrate me-2'></i> Show de Luces
                </p>
                <div className="alert alert-dark py-2 px-3 mb-0 font-weight-bold shadow-sm" style={{ fontSize: '0.9rem' }}>
                    <i className="bi bi-broadcast-pin me-2"></i> Status: {currentSystemStatus}
                </div>
            </div>

            <div className="row">
                {/* BLOQUE 1: CONSTRUCTOR DE CICLOS */}
                <div className="col-md-7 mb-4">
                    <div className="card shadow-sm h-100 border-dark">
                        <div className="card-header bg-dark text-white font-weight-bold d-flex justify-content-between align-items-center">
                            <span><i className="bi bi-palette-fill me-2"></i> 1. Ciclo de Colores (Frames)</span>
                            <div className="d-flex align-items-center">
                                <label className="mb-0 me-2 small">BPM (Ritmo):</label>
                                <input 
                                    type="number" 
                                    className="form-control form-control-sm text-center font-weight-bold" 
                                    style={{ width: '120px' }} 
                                    value={beatsPerMinute} 
                                    onChange={(e) => setBeatsPerMinute(parseInt(e.target.value) || 0)} 
                                />
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-bordered table-hover mb-0 align-middle text-center">
                                <thead className="table-light">
                                    <tr>
                                        <th># de frame</th>
                                        <th>Color de pantalla</th>
                                        <th>¿Flash prendido o apagado?</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {animationFrames.map((frame, index) => (
                                        <tr key={frame.id}>
                                            <td className="font-weight-bold">{index + 1}</td>
                                            <td>
                                                <div className="d-flex justify-content-center align-items-center">
                                                    <input 
                                                        type="color" 
                                                        className="form-control form-control-color border-0 p-0 me-2" 
                                                        value={frame.color} 
                                                        onChange={(e) => updateFrame(frame.id, 'color', e.target.value)} 
                                                        style={{ width: '40px', height: '30px' }} 
                                                    />
                                                    <span className="small text-muted font-monospace">{frame.color.toUpperCase()}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="form-check form-switch d-flex justify-content-center">
                                                    <input 
                                                        className="form-check-input" 
                                                        type="checkbox" 
                                                        checked={frame.flashOn} 
                                                        onChange={(e) => updateFrame(frame.id, 'flashOn', e.target.checked)} 
                                                        style={{ cursor: 'pointer', width: '40px', height: '20px' }} 
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => removeFrame(frame.id)} title="Borrar Frame">
                                                    <i className="bi bi-trash3-fill"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* FOOTER CON BOTONES DE MEMORIA Y PRESETS */}
                        <div className="card-footer bg-light d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <button className="btn btn-sm btn-outline-success font-weight-bold" onClick={addFrame}>
                                <i className="bi bi-plus-circle-fill me-1"></i> Agregar Frame
                            </button>
                            
                            <div className="d-flex align-items-center flex-wrap gap-2">
                                <span className="text-muted small font-weight-bold">Presets:</span>
                                <button className={`btn btn-sm btn-${presetLoaded === PRESETS.BASICO ? 'success' : 'outline-secondary'}`} onClick={() => loadPreset(PRESETS.BASICO)}>Básico</button>
                                <button className={`btn btn-sm btn-${presetLoaded === PRESETS.NOPODRAS_KARAOKE ? 'success' : 'outline-secondary'}`} onClick={() => loadPreset(PRESETS.NOPODRAS_KARAOKE)}>No podrás (Karaoke)</button>
                                <button className={`btn btn-sm btn-${presetLoaded === PRESETS.KILOMETROS_KARAOKE ? 'success' : 'outline-secondary'}`} onClick={() => loadPreset(PRESETS.KILOMETROS_KARAOKE)}>Kilómetros (Karaoke)</button>
                                <button className={`btn btn-sm btn-${presetLoaded === PRESETS.SIRENA ? 'success' : 'outline-secondary'}`} onClick={() => loadPreset(PRESETS.SIRENA)}>Sirena</button>
                                
                                <span className="text-muted small font-weight-bold ms-2 border-start ps-3">Memoria:</span>
                                <button className="btn btn-sm btn-primary" onClick={saveCustomCycleToMemory} title="Guardar configuración actual en el navegador">
                                    <i className="bi bi-floppy-fill me-1"></i> Guardar
                                </button>
                                <button className="btn btn-sm btn-outline-danger" onClick={clearCustomCycleFromMemory} title="Borrar lo guardado y regresar a básico">
                                    <i className="bi bi-eraser-fill me-1"></i> Borrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* BLOQUE 2: BOTONERA DE CONTROLES MAESTROS */}
                <div className="col-md-5 mb-4">
                    <div className="card shadow-sm h-100 border-primary">
                        <div className="card-header bg-primary text-white font-weight-bold">
                            <i className="bi bi-joystick me-2"></i> 2. Controles Maestros
                        </div>
                        <div className="card-body d-flex flex-column">
                            
                            <div className="alert alert-primary bg-light border-primary pb-3 pt-3 mb-4 shadow-sm">
                                <h6 className="font-weight-bold text-primary text-center mb-3">PASOS A SEGUIR</h6>
                                <ol className="mb-0 small text-dark pl-3">
                                    <li className="mb-2"><strong>Preparar:</strong> Los celulares mostrarán un botón para pedir permisos al usuario.</li>
                                    <li className="mb-2"><strong>Iniciar:</strong> Los flashes comenzarán a parpadear al ritmo seleccionado.</li>
                                    <li><strong>Detener:</strong> Apaga los flashes y libera las cámaras de los usuarios.</li>
                                </ol>
                            </div>

                            <button className="btn btn-outline-primary mb-3 btn-lg font-weight-bold" 
                                onClick={() => triggerModal('Esto enviará la configuración de colores a los dispositivos y pedirá permisos. ¿Continuar?', executePrepareShow, 'Paso 1: Preparar')}>
                                <i className="bi bi-person-raised-hand me-2"></i> Paso 1: PREPARAR / ENVIAR
                            </button>
                            
                            <button className="btn btn-success mb-4 btn-lg font-weight-bold shadow" 
                                onClick={() => triggerModal('¿Arrancar el show de luces en este momento o aplicar los nuevos BPM/Colores al show en curso?', executeStartShow, '¡ARRANCAR SHOW!')}>
                                <i className="bi bi-lightning-charge-fill me-2"></i> Paso 2: INICIAR / ACTUALIZAR
                            </button>
                            
                            <hr className="w-100 mt-auto" />
                            
                            <button className="btn btn-danger font-weight-bold w-100" 
                                onClick={() => triggerModal('¿Detener el show y apagar las luces? (Los celulares seguirán en la pantalla listos por si quieres volver a iniciar).', executeStopShow, 'Sí, Detener')}>
                                <i className="bi bi-stop-circle-fill me-1"></i> Detener / Apagar Luces
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            {/* INTEGRACIÓN DEL MODAL ESTANDARIZADO */}
            {showConfirmModal && (
                <Confirm 
                    message={confirmModalData?.message} 
                    actionToYesButton={confirmModalData?.actionToYesButton} 
                    textYesButton={confirmModalData?.textYesButton} 
                    textNoButton={confirmModalData?.textNoButton} 
                    setShowModal={setShowConfirmModal} 
                    setConfirmData={setConfirmModalData} 
                />
            )}
        </SecondaryBase>
    )
}

export { LightShow };


















// const LightShow = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage()

//     const [beatsPerMinute, setBeatsPerMinute] = useState(120);
//     const [currentSystemStatus, setCurrentSystemStatus] = useState('Juego inactivo. Configura el ritmo y colores.');

//     // CONSTRUCTOR DE FRAMES DE COLOR Y LUZ
//     // Cada elemento es MEDIO LATIDO. 
//     // Ejemplo por defecto: Medio latido Azul (Flash ON), Medio latido Negro (Flash OFF)
//     const [animationFrames, setAnimationFrames] = useState([
//         { id: 1, color: '#0000FF', flashOn: true },
//         { id: 2, color: '#000000', flashOn: false }
//     ]);

//     const [showConfirmModal, setShowConfirmModal] = useState(false);
//     const [confirmModalData, setConfirmModalData] = useState(null);

//     // ==========================================
//     // MÉTODOS DEL CONSTRUCTOR DE FRAMES
//     // ==========================================
//     const addFrame = () => {
//         const newFrame = { id: Date.now(), color: '#FF0000', flashOn: true };
//         setAnimationFrames([...animationFrames, newFrame]);
//     };

//     const removeFrame = (frameId) => {
//         if (animationFrames.length <= 2) {
//             showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Debes tener al menos 2 frames para hacer un ciclo.' });
//             return;
//         }
//         setAnimationFrames(animationFrames.filter(frame => frame.id !== frameId));
//     };

//     const updateFrame = (frameId, property, value) => {
//         setAnimationFrames(prev => prev.map(frame => frame.id === frameId ? { ...frame, [property]: value } : frame));
//     };

//     const loadPreset = (type) => {
//         if (type === 'police') {
//             setAnimationFrames([
//                 { id: 1, color: '#0000FF', flashOn: true },  { id: 2, color: '#000000', flashOn: false },
//                 { id: 3, color: '#FF0000', flashOn: true },  { id: 4, color: '#000000', flashOn: false }
//             ]);
//         } else if (type === 'basic') {
//             setAnimationFrames([
//                 { id: 1, color: '#FFFFFF', flashOn: true },  { id: 2, color: '#000000', flashOn: false }
//             ]);
//         }
//     };

//     // ==========================================
//     // MÉTODOS DE LA BATUTA (API)
//     // ==========================================
//     const executePrepareShow = async () => {
//         // Le mandamos los BPM y la lista de Frames armada
//         const response = await BLPrepare(beatsPerMinute, animationFrames);
//         if (response?.success) {
//             setCurrentSystemStatus('Modo Preparación: Los celulares están pidiendo permisos 📲');
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Señal de preparación enviada.' });
//             return { success: true };
//         }
//         return { success: false, message: response?.message };
//     };

//     const executeStartShow = async () => {
//         const response = await BLStart();
//         if (response?.success) {
//             setCurrentSystemStatus(`¡SHOW EN CURSO! 🌟 (${beatsPerMinute} BPM)`);
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: '¡El show de luces está corriendo!' });
//             return { success: true };
//         }
//         return { success: false, message: response?.message };
//     };

//     const executeStopShow = async () => {
//         const response = await BLStop();
//         if (response?.success) {
//             setCurrentSystemStatus('Show Detenido 🛑 (Mantiene permisos en usuarios)');
//             showMessage({ type: MESSAGE_TYPE.INFO, text: 'Las luces se han apagado.' });
//             return { success: true };
//         }
//         return { success: false, message: response?.message };
//     };

//     const triggerModal = (msg, action, yesText) => {
//         setConfirmModalData({ message: msg, actionToYesButton: action, textYesButton: yesText, textNoButton: 'Cancelar' });
//         setShowConfirmModal(true);
//     };

//     const ReturnToDashboard = async () => {
//         try { await BLResetCurrentDynamic(); getOutOfTheDynamic(); } catch (error) {}
//     };

//     return (
//         <SecondaryBase actionToExecute={ReturnToDashboard}>
//             <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
//                 <p className='AdmRunToGoal__Title mb-3 mb-md-0'><i className='bi bi-phone-vibrate me-2'></i> Show de Luces</p>
//                 <div className="alert alert-dark py-2 px-3 mb-0 font-weight-bold shadow-sm" style={{ fontSize: '0.9rem' }}>
//                     <i className="bi bi-broadcast-pin me-2"></i> Status: {currentSystemStatus}
//                 </div>
//             </div>

//             <div className="row">
//                 {/* CONFIGURADOR DE CICLOS */}
//                 <div className="col-md-7 mb-4">
//                     <div className="card shadow-sm h-100 border-dark">
//                         <div className="card-header bg-dark text-white font-weight-bold d-flex justify-content-between align-items-center">
//                             <span><i className="bi bi-palette-fill me-2"></i> 1. Ciclo de Colores (Frames)</span>
//                             <div className="d-flex align-items-center">
//                                 <label className="mb-0 me-2 small">BPM:</label>
//                                 <input type="number" className="form-control form-control-sm text-center font-weight-bold" style={{ width: '80px' }} value={beatsPerMinute} onChange={(e) => setBeatsPerMinute(parseInt(e.target.value) || 0)} />
//                             </div>
//                         </div>
//                         <div className="card-body p-0">
//                             <table className="table table-bordered table-hover mb-0 align-middle text-center">
//                                 <thead className="table-light">
//                                     <tr>
//                                         <th>Frame</th>
//                                         <th>Color Pantalla</th>
//                                         <th>Flash Físico</th>
//                                         <th>Acción</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {animationFrames.map((frame, index) => (
//                                         <tr key={frame.id}>
//                                             <td className="font-weight-bold">{index + 1}</td>
//                                             <td>
//                                                 <div className="d-flex justify-content-center align-items-center">
//                                                     <input type="color" className="form-control form-control-color border-0 p-0 me-2" value={frame.color} onChange={(e) => updateFrame(frame.id, 'color', e.target.value)} style={{ width: '40px', height: '30px' }} />
//                                                     <span className="small text-muted">{frame.color.toUpperCase()}</span>
//                                                 </div>
//                                             </td>
//                                             <td>
//                                                 <div className="form-check form-switch d-flex justify-content-center">
//                                                     <input className="form-check-input" type="checkbox" checked={frame.flashOn} onChange={(e) => updateFrame(frame.id, 'flashOn', e.target.checked)} style={{ cursor: 'pointer' }} />
//                                                 </div>
//                                             </td>
//                                             <td>
//                                                 <button className="btn btn-sm btn-outline-danger" onClick={() => removeFrame(frame.id)}><i className="bi bi-trash3-fill"></i></button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                         <div className="card-footer bg-light d-flex justify-content-between">
//                             <button className="btn btn-sm btn-outline-success font-weight-bold" onClick={addFrame}>
//                                 <i className="bi bi-plus-circle-fill me-1"></i> Agregar Frame
//                             </button>
//                             <div>
//                                 <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => loadPreset('basic')}>Preset: Clásico</button>
//                                 <button className="btn btn-sm btn-outline-primary" onClick={() => loadPreset('police')}>Preset: Sirena (Azul/Rojo)</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* BOTONERA */}
//                 <div className="col-md-5 mb-4">
//                     <div className="card shadow-sm h-100 border-primary">
//                         <div className="card-header bg-primary text-white font-weight-bold"><i className="bi bi-joystick me-2"></i> 2. Controles Maestros</div>
//                         <div className="card-body d-flex flex-column">
                            
//                             <button className="btn btn-outline-primary mb-3 btn-lg font-weight-bold" 
//                                 onClick={() => triggerModal('Esto enviará la configuración de colores a los dispositivos y pedirá permisos. ¿Continuar?', executePrepareShow, 'Paso 1: Preparar')}>
//                                 <i className="bi bi-person-raised-hand me-2"></i> Paso 1: PREPARAR / ENVIAR
//                             </button>
                            
//                             <button className="btn btn-success mb-4 btn-lg font-weight-bold shadow" 
//                                 onClick={() => triggerModal('¿Arrancar el show de luces en este momento o aplicar los nuevos BPM al show en curso?', executeStartShow, '¡ARRANCAR SHOW!')}>
//                                 <i className="bi bi-lightning-charge-fill me-2"></i> Paso 2: INICIAR / ACTUALIZAR
//                             </button>
                            
//                             <hr className="w-100 mt-auto" />
                            
//                             <button className="btn btn-danger font-weight-bold w-100" 
//                                 onClick={() => triggerModal('¿Detener el show y apagar las luces? (Los celulares seguirán en la pantalla listos por si quieres volver a iniciar).', executeStopShow, 'Sí, Detener')}>
//                                 <i className="bi bi-stop-circle-fill me-1"></i> Detener / Apagar Luces
//                             </button>

//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {showConfirmModal && (
//                 <Confirm message={confirmModalData?.message} actionToYesButton={confirmModalData?.actionToYesButton} textYesButton={confirmModalData?.textYesButton} textNoButton={confirmModalData?.textNoButton} setShowModal={setShowConfirmModal} setConfirmData={setConfirmModalData} />
//             )}
//         </SecondaryBase>
//     )
// }

// export { LightShow };











// /**
//  * Componente LightShow (Admin)
//  * Panel de control para el operador de la dinámica de Sincronización de Flashes.
//  */
// const LightShow = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage()

//     // ==========================================
//     // 1. ESTADOS DE CONFIGURACIÓN DEL SHOW
//     // ==========================================
//     const [beatsPerMinute, setBeatsPerMinute] = useState(120);
//     const [themeColor, setThemeColor] = useState('#ffffff'); // Blanco por defecto
//     const [currentSystemStatus, setCurrentSystemStatus] = useState('Juego inactivo. Configura el ritmo y el color.');

//     // ==========================================
//     // 2. ESTADOS DEL MODAL DE CONFIRMACIÓN
//     // ==========================================
//     const [showConfirmModal, setShowConfirmModal] = useState(false);
//     const [confirmModalData, setConfirmModalData] = useState(null);

//     // ==========================================
//     // 3. FUNCIONES DE CONTROL (Llaman a la capa BL)
//     // ==========================================
    
//     const executePrepareShow = async () => {
//         showMessage({ type: MESSAGE_TYPE.INFO, text: 'Enviado mensaje a pantalla y aficionados...' });

//         const response = await BLPrepare(beatsPerMinute, themeColor);
        
//         if (response?.success) {
//             setCurrentSystemStatus('Modo Preparación: Los celulares están pidiendo permisos 📲');
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Señal de preparación enviada exitosamente.' });
//             return { success: true };
//         } else {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Error desconocido al preparar.' });
//             return { success: false, message: response?.message || 'Error desconocido al preparar.' };
//         }
//     };

//     const executeStartShow = async () => {
//         showMessage({ type: MESSAGE_TYPE.INFO, text: 'Iniciado el encendido de luces...' });

//         const response = await BLStart();
        
//         if (response?.success) {
//             setCurrentSystemStatus('¡SHOW EN CURSO! Luces parpadeando 🌟');
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: '¡El show de luces ha comenzado sincronizado!' });
//             return { success: true };
//         } else {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Error desconocido al iniciar.' });
//             return { success: false, message: response?.message || 'Error desconocido al iniciar.' };
//         }
//     };

//     const executeStopShow = async () => {
//         showMessage({ type: MESSAGE_TYPE.INFO, text: 'Apagando luces...' });

//         const response = await BLStop();
        
//         if (response?.success) {
//             setCurrentSystemStatus('Show Detenido 🛑');
//             showMessage({ type: MESSAGE_TYPE.INFO, text: 'Las linternas se han apagado.' });
//             return { success: true };
//         } else {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: response?.message || 'Error desconocido al detener.' });
//             return { success: false, message: response?.message || 'Error desconocido al detener.' };
//         }
//     };

//     // Helper para abrir el modal estandarizado
//     const triggerModal = (messageText, actionFunction, yesBtnText = 'Confirmar', noBtnText = 'Cancelar') => {
//         setConfirmModalData({
//             message: messageText,
//             actionToYesButton: actionFunction,
//             textYesButton: yesBtnText,
//             textNoButton: noBtnText
//         });
//         setShowConfirmModal(true);
//     };

//     // ==========================================
//     // 4. RETORNO AL DASHBOARD
//     // ==========================================
//     const ReturnToDashboard = async () => {
//         try {
//             showMessage({ type: MESSAGE_TYPE.INFO, text: 'Regresando al dashboard...' });
//             await BLResetCurrentDynamic();
//             getOutOfTheDynamic();
//         } catch (error) {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: 'Error al regresar al dashboard' });
//             console.error("Error al regresar al dashboard", error);
//         }
//     };


//     return (
//         <SecondaryBase actionToExecute={ReturnToDashboard}>
//             {/* Cabecera y Estatus */}
//             <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
//                 <p className='AdmRunToGoal__Title mb-3 mb-md-0'>
//                     <i className='bi bi-phone-vibrate me-2'></i> Show de Luces
//                 </p>
//                 <div className="alert alert-dark py-2 px-3 mb-0 font-weight-bold shadow-sm" style={{ fontSize: '0.9rem' }}>
//                     <i className="bi bi-broadcast-pin me-2"></i> Status: {currentSystemStatus}
//                 </div>
//             </div>

//             <div className="row">
//                 {/* BLOQUE 1: CONFIGURACIÓN DEL SHOW */}
//                 <div className="col-md-6 mb-4">
//                     <div className="card shadow-sm h-100 border-dark">
//                         <div className="card-header bg-dark text-white font-weight-bold">
//                             <i className="bi bi-sliders me-2"></i> 1. Ajustes del Show
//                         </div>
//                         <div className="card-body">
//                             <p className="text-muted small mb-4">
//                                 Configura la velocidad del parpadeo (BPM) y el color que se mostrará en las pantallas de los dispositivos.
//                             </p>

//                             <div className="mb-4">
//                                 <label className="font-weight-bold d-block">
//                                     <i className="bi bi-heart-pulse-fill text-danger me-1"></i> Velocidad (BPM)
//                                 </label>
//                                 <input 
//                                     type="number" 
//                                     className="form-control form-control-lg text-center font-weight-bold" 
//                                     value={beatsPerMinute} 
//                                     onChange={(e) => setBeatsPerMinute(parseInt(e.target.value) || 0)}
//                                     min="1" 
//                                     max="300"
//                                 />
//                                 <div className="d-flex justify-content-between mt-2">
//                                     {/* <button className="btn btn-sm btn-outline-secondary" onClick={() => setBeatsPerMinute(60)}>60 (Lento)</button> */}
//                                     <button className="btn btn-sm btn-outline-secondary" onClick={() => setBeatsPerMinute(118)}>118 (No podrás)</button>
//                                     {/* <button className="btn btn-sm btn-outline-secondary" onClick={() => setBeatsPerMinute(120)}>120 (Normal)</button> */}
//                                     <button className="btn btn-sm btn-outline-secondary" onClick={() => setBeatsPerMinute(171)}>171 (Kilómetros)</button>
//                                     {/* <button className="btn btn-sm btn-outline-secondary" onClick={() => setBeatsPerMinute(180)}>180 (Rápido)</button> */}
//                                 </div>
//                             </div>

//                             <div className="mb-3">
//                                 <label className="font-weight-bold d-block">
//                                     <i className="bi bi-palette-fill text-info me-1"></i> Color de Pantalla
//                                 </label>
//                                 <div className="d-flex align-items-center">
//                                     <input 
//                                         type="color" 
//                                         className="form-control form-control-color border-0 p-0 me-3 border rounded" 
//                                         value={themeColor} 
//                                         onChange={(e) => setThemeColor(e.target.value)}
//                                         style={{ width: '60px', height: '50px', cursor: 'pointer' }}
//                                     />
//                                     <div className="flex-grow-1">
//                                         <p className="mb-0 font-weight-bold">{themeColor.toUpperCase()}</p>
//                                         <small className="text-muted">El flash siempre será blanco, este color es para la pantalla del celular.</small>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* BLOQUE 2: CONTROLES DE EJECUCIÓN */}
//                 <div className="col-md-6 mb-4">
//                     <div className="card shadow-sm h-100 border-primary">
//                         <div className="card-header bg-primary text-white font-weight-bold">
//                             <i className="bi bi-joystick me-2"></i> 2. Controles de Arena
//                         </div>
//                         <div className="card-body d-flex flex-column">
                            
//                             <div className="alert alert-primary bg-light border-primary pb-3 pt-3 mb-4 shadow-sm">
//                                 <h6 className="font-weight-bold text-primary text-center mb-3">PASOS A SEGUIR</h6>
//                                 <ol className="mb-0 small text-dark pl-3">
//                                     <li className="mb-2"><strong>Preparar:</strong> Los celulares mostrarán un botón para pedir permisos al usuario.</li>
//                                     <li className="mb-2"><strong>Iniciar:</strong> Los flashes comenzarán a parpadear al ritmo seleccionado.</li>
//                                     <li><strong>Detener:</strong> Apaga los flashes y libera las cámaras de los usuarios.</li>
//                                 </ol>
//                             </div>

//                             <button className="btn btn-outline-primary mb-3 btn-lg font-weight-bold" 
//                                 onClick={() => triggerModal('¿Llamar a los usuarios para que concedan permisos de linterna/cámara?', executePrepareShow, 'Sí, Enviar Preparación')}>
//                                 <i className="bi bi-person-raised-hand me-2"></i> Paso 1: Preparar Celulares
//                             </button>
                            
//                             <button className="btn btn-success mb-4 btn-lg font-weight-bold shadow" style={{ fontSize: '1.2rem' }}
//                                 onClick={() => triggerModal('¿Arrancar el show de luces en este momento?', executeStartShow, '¡INICIAR SHOW!', 'Cancelar')}>
//                                 <i className="bi bi-lightning-charge-fill me-2"></i> Paso 2: Iniciar show
//                             </button>
                            
//                             <hr className="w-100 mt-auto" />
                            
//                             <button className="btn btn-danger font-weight-bold w-100" 
//                                 onClick={() => triggerModal('¿Detener el show y apagar las luces de todos los dispositivos?', executeStopShow, 'Sí, Detener todo', 'Cancelar')}>
//                                 <i className="bi bi-stop-circle-fill me-1"></i> Detener / Apagar Luces
//                             </button>

//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* INTEGRACIÓN DEL MODAL ESTANDARIZADO */}
//             {showConfirmModal && (
//                 <Confirm 
//                     message={confirmModalData?.message}
//                     actionToYesButton={confirmModalData?.actionToYesButton}
//                     textYesButton={confirmModalData?.textYesButton}
//                     textNoButton={confirmModalData?.textNoButton}
//                     setShowModal={setShowConfirmModal}
//                     setConfirmData={setConfirmModalData} 
//                 />
//             )}

//         </SecondaryBase>
//     )
// }

// export { LightShow };